// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5f94e233","498":"4aa30c3f","703":"0f0d6939","787":"59cadb1e"}[chunkId] + ".chunk.js";
};